/** Eén sessie laden en elke 5 s verversen (pauze als het tabblad verborgen is). Alle state komt van de server. */
import { useCallback, useEffect, useRef, useState } from 'react';
import { overlegApi } from './overlegApi';

export const POLL_MS = 5000;

export default function useOverlegSessie(sessieId, { weken = 0 } = {}) {
  const [data, setData] = useState(null);
  const [laden, setLaden] = useState(true);
  const [fout, setFout] = useState('');
  const bezig = useRef(false);

  const herlaad = useCallback(async (stil = true) => {
    if (!sessieId || bezig.current) return;
    bezig.current = true;
    if (!stil) setLaden(true);
    try {
      const d = await overlegApi.sessie(sessieId, weken);
      setData(d);
      setFout('');
    } catch (e) {
      setFout(e.message || 'Laden mislukt');
      if (e.status === 404) setData(null);
    } finally {
      bezig.current = false;
      setLaden(false);
    }
  }, [sessieId, weken]);

  useEffect(() => { herlaad(false); }, [herlaad]);

  useEffect(() => {
    if (!sessieId) return undefined;
    const tik = () => { if (!document.hidden) herlaad(true); };
    const id = setInterval(tik, POLL_MS);
    const opZicht = () => { if (!document.hidden) herlaad(true); };
    document.addEventListener('visibilitychange', opZicht);
    return () => { clearInterval(id); document.removeEventListener('visibilitychange', opZicht); };
  }, [sessieId, herlaad]);

  const actie = useCallback(async (naam, body = {}) => {
    const d = await overlegApi.live(sessieId, naam, body);
    if (d && d.sessie) setData(d);
    else herlaad(true);
    return d;
  }, [sessieId, herlaad]);

  return { data, laden, fout, herlaad, actie, setData };
}
